import service from '@/services/integrations'
const namespaced = true
const state = {
  list: [],
  conflicts: [],
  integrationInfo: {}
}
const getters = {
  getIntegrationsList: state => state.list,
  getSynchronizationConflicts: state => state.conflicts,
  getIntegrationInfo: state => state.integrationInfo
}
const actions = {
  async loadIntegrationsList({ commit, dispatch }) {
    const response = await service.getAllSyncs()
    if (response?.data?.error?.type === 200) {
      if (Array.isArray(response.data.data)) {
        commit('setIntegrationsList', response.data.data)
      } else {
        commit('setIntegrationsList', [])
      }
    }
  },
  async handleSyncMode({ commit, dispatch }, payload) {
    await service.setSyncMode(payload)
  }
}
const mutations = {
  setIntegrationsList(state, payload) {
    state.list = payload
  },
  setIntegrationInfo(state, payload) {
    state.integrationInfo = payload
  },
  setSynchronizationConflicts(state, payload) {
    state.conflicts = payload
  }
}
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
